import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ProcessSection } from '../components/ProcessSection';
import { ImpactSection } from '../components/ImpactSection';
import { LeadershipSection } from '../components/LeadershipSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { TeamSection } from '../components/TeamSection';
import { PartnershipsSection } from '../components/PartnershipsSection';
import { EventsSection } from '../components/EventsSection';
import { DonateSection } from '../components/DonateSection';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
export function Home() {
  useDocumentMeta({
    title: 'Pancita Feliz Foundation | Transformando el Neurodesarrollo Familiar',
    description: 'Fundación dedicada a transformar la biología familiar para mejorar el neurodesarrollo. Educación, orientación y acceso a abordajes biomédicos para familias con pocos recursos.',
    path: '/'
  });
  return <>
      <HeroSection data-id="element-422" data-mp="2vyzxzoneqfce" />
      <ProblemSection data-id="element-423" data-mp="2vyhwodlw1axm" />
      <SolutionSection data-id="element-424" data-mp="2qylnlzyc2tb7" />
      <ProcessSection data-id="element-425" data-mp="2qxu4vppu4q2c" />
      <ImpactSection data-id="element-426" data-mp="2qxakm2cpppl5" />
      <LeadershipSection data-id="element-427" data-mp="2qwsk2tj0op7f" />
      <TestimonialsSection data-id="element-428" data-mp="2mx0gkv8hd98x" />
      <TeamSection data-id="element-429" data-mp="2mxs037oszgiu" />
      <PartnershipsSection data-id="element-430" data-mp="2mw8mxpyg1lla" />
      <EventsSection data-id="element-431" data-mp="2mz385jpa7afr" />
      <DonateSection data-id="element-432" data-mp="2hxnjzirt4nt5" />
    </>;
}